import type { DirectusFiles } from "./data/collections"

export function getDirectusURL(path = '') {
    return `${
      process.env.NEXT_PUBLIC_DIRECTUS_URL || 'https://api.chewy.build'
    }${path}`
  }
export function getDirectusMedia(
    url: string | string | {
      filename_disk: string;
      height: number;
      width: number;
    } | null | undefined
  ) {
    if (url == null || typeof url === undefined) {
      return ''
    }


    // Otherwise prepend the URL path with the Strapi URL
    return `${getDirectusURL()}/assets/${url}`
  }